import { createPortal } from "react-dom";

const PortalWrapper = ({ children }) => {
  return createPortal(children, document.body);
};

export default PortalWrapper;